import { Inject, Module } from '@nestjs/common';
import { QueryResolver } from './query.resolver';
import { MutationResolver } from './mutation.resolver';
import { ConnectDocsProvider } from './docs';
import { setStore } from './auth0-pcke';
import { NotificationService } from './notification.service';

@Module({
  providers: [
    QueryResolver,
    MutationResolver,
    NotificationService,
    ConnectDocsProvider
  ]
})
export class AngularConsoleExtensionsModule {
  constructor(
    @Inject('store') private readonly store: any,
    notificationService: NotificationService
  ) {
    setStore(store);
    notificationService.setUpNotifications();
  }
}
